import { useApiClient } from '@/api/useApiClient';

export async function getStudentPhoto(studentId: string): Promise<Blob | null> {
  if (!studentId) {
    throw new Error('Student ID is required');
  }

  try {
    const client = useApiClient()
     const { data, error, response } = await client.GET(`/parent/students/{studentId}/photo`, {
      params: {
        path: { studentId }
      },
    
      parseAs: 'blob' 
    });
 if (error) {
      if (response?.status === 404) {
        return null;
      }
      throw new Error(`Failed to get student photo: ${response?.status} ${error.message || ''}`);
    }

    return data as Blob;
  } catch (error: any) {
    console.error('Error fetching student photo:', error);
    throw error;
  }
};


export function createPhotoUrl(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function revokePhotoUrl(url: string): void {
  URL.revokeObjectURL(url);
}

